import { useRouteQuery } from "shared/hooks/useRouteQuery";

export const useSharedAdReview = () => {
  const sharedAdReviewId = useRouteQuery("sharedAdReviewId");

  return !!sharedAdReviewId;
};
